<template>
    <div>
        <el-dialog :title="tit" v-model="editFormVisible" :visible.sync="editFormVisible" :close-on-click-modal="false">
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                <el-form-item label="部门名称">
                    <el-input v-model="form.FName"></el-input>
                </el-form-item>
                <el-form-item label="组织代码">
                    <el-input v-model="form.FCode"></el-input>
                </el-form-item>
                <el-form-item label="部门负责人">
                    <el-input v-model="form.FLeader"></el-input>
                </el-form-item>
                <el-form-item label="总监">
                    <el-input v-model="form.FUpLeader"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input type="textarea" v-model="form.FNote"></el-input>
                </el-form-item>
                <el-form-item label="父部门ID">
                    <el-input v-model="form.FParentID"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="save" :loading="loading">保存</el-button>
            </div>
      </el-dialog>
    </div>
</template>

<script>
    import util from '../../common/util'
    export default {
        data() {
            return {
                form: {},
                rules: {
                    FName: [{required: true,message: '团队名称', trigger: 'change'}]
                },
                loading:false,
                editFormVisible:false,
                tit:''
            }
        },
        methods: {
            switchLoading(flag){
                this.loading = flag;
            },
            _openEdit(record) {
                this.editFormVisible = true;
                this.form = Object.assign({},record);
                this.tit = '编辑';
            },
            _openAdd(record) {
                this.editFormVisible = true;
                this.form = Object.assign({FID:0,FLeader:''},record);
                this.tit = '新增';
            },
            save:function () {
                util.post("server/system/Dept.ashx?cmd=Save",this.form,this.switchLoading,result=> {
                    util.msgSuc("保存成功")
                    this.editFormVisible = false
                    this.$emit("onSaveSuc",this.form)
                })
            }
        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/system/Dept_Edit.vue